export default {"src":"/_next/static/media/paddleboard.86098ac3.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};